import { render, staticRenderFns } from "./Materials_Surface_Finishes.vue?vue&type=template&id=09c5c640&scoped=true"
import script from "./Materials_Surface_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Materials_Surface_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Materials_Surface_Finishes.vue?vue&type=style&index=0&id=09c5c640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5c640",
  null
  
)

export default component.exports